module.exports = {
    config: require('./config'),
    procedures: {
        bank_deposit_create: {
            definition: require('./bank_deposit_create/definition.json'),
            mock_data: require('./bank_deposit_create/mock_data.json'),
        },
        bank_deposit_delete: {
            definition: require('./bank_deposit_delete/definition.json'),
            mock_data: require('./bank_deposit_delete/mock_data.json'),
        },
        bank_deposit_list: {
            definition: require('./bank_deposit_list/definition.json'),
            mock_data: require('./bank_deposit_list/mock_data.json'),
        },
        bank_deposit_update: {
            definition: require('./bank_deposit_update/definition.json'),
            mock_data: require('./bank_deposit_update/mock_data.json'),
        },
        batch_create: {
            definition: require('./batch_create/definition.json'),
            mock_data: require('./batch_create/mock_data.json'),
        },
        batch_list: {
            definition: require('./batch_list/definition.json'),
            mock_data: require('./batch_list/mock_data.json'),
        },
        batch_read: {
            definition: require('./batch_read/definition.json'),
            mock_data: require('./batch_read/mock_data.json'),
        },
        merchant_read: {
            definition: require('./merchant_read/definition.json'),
            mock_data: require('./merchant_read/mock_data.json'),
        },
        merchant_list: {
            definition: require('./merchant_list/definition.json'),
            mock_data: require('./merchant_list/mock_data.json'),
        },
        wallet_create: {
            definition: require('./wallet_create/definition.json'),
            mock_data: require('./wallet_create/mock_data.json'),
        },
        wallet_list: {
            definition: require('./wallet_list/definition.json'),
            mock_data: require('./wallet_list/mock_data.json'),
        },
        wallet_update: {
            definition: require('./wallet_update/definition.json'),
            mock_data: require('./wallet_update/mock_data.json'),
        },
        payment_create: {
            definition: require('./payment_create/definition.json'),
            mock_data: require('./payment_create/mock_data.json'),
        },
        deposit_bank_deposit_create: {
            definition: require('./deposit_bank_deposit_create/definition.json'),
            mock_data: require('./deposit_bank_deposit_create/mock_data.json'),
        },
        deposit_bank_deposit_delete: {
            definition: require('./deposit_bank_deposit_delete/definition.json'),
            mock_data: require('./deposit_bank_deposit_delete/mock_data.json'),
        },
        deposit_bank_deposit_list: {
            definition: require('./deposit_bank_deposit_list/definition.json'),
            mock_data: require('./deposit_bank_deposit_list/mock_data.json'),
        },
        deposit_create: {
            definition: require('./deposit_create/definition.json'),
            mock_data: require('./deposit_create/mock_data.json'),
        },
        deposit_update: {
            definition: require('./deposit_update/definition.json'),
            mock_data: require('./deposit_update/mock_data.json'),
        },
        deposit_list: {
            definition: require('./deposit_list/definition.json'),
            mock_data: require('./deposit_list/mock_data.json'),
        },
        deposit_read: {
            definition: require('./deposit_read/definition.json'),
            mock_data: require('./deposit_read/mock_data.json'),
        },
        payment_update: {
            definition: require('./payment_update/definition.json'),
            mock_data: require('./payment_update/mock_data.json'),
        },
        payment_list: {
            definition: require('./payment_list/definition.json'),
            mock_data: require('./payment_list/mock_data.json'),
        },
        payment_read: {
            definition: require('./payment_read/definition.json'),
            mock_data: require('./payment_read/mock_data.json'),
        },
        payment_type_list: {
            definition: require('./payment_type_list/definition.json'),
            mock_data: require('./payment_type_list/mock_data.json'),
        },
        transaction_create: {
            definition: require('./transaction_create/definition.json'),
            mock_data: require('./transaction_create/mock_data.json')
        },
        provider_account_read: {
            definition: require('./provider_account_read/definition.json'),
            mock_data: require('./provider_account_read/mock_data.json')
        }
    }
};
